/* eslint-disable complexity */
import {
  BookWidgetAem,
  BookWidgetBasicFaresField
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { CatalogApiFieldsValue } from '../../models/core-apis/catalog-api.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';
import { basicFaresFieldCheckedValue } from '../utils/utils.adapter';

export const prepareBasicFaresField = (
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig,
  catalogApiFieldsValue: CatalogApiFieldsValue | null,
  retrieveSearchData: RetrieveSearchData | null,
  bookWidgetAem: BookWidgetAem | null
): BookWidgetBasicFaresField => {
  let checked = basicFaresFieldCheckedValue(
    catalogApiFieldsValue,
    bookWidgetAem
  );

  if (
    !bookWidgetFieldsMasterConfig.basicFaresField?.hide &&
    retrieveSearchData?.includeBasicFaresUnchecked
  ) {
    checked = false;
  }

  return {
    checked: checked,
    disable: false,
    hide: bookWidgetFieldsMasterConfig.basicFaresField?.hide || false
  };
};
